import { useState } from 'react';
import { IMG_PLACEHOLDER_PRODUCT, PROFILE_COLLECTION_EDIT_LINK } from '../../../../assets/utils/constants';
import { parsePrice, parseTitleForParts } from '../../../../assets/utils/utils';
import ImageWithBackground from '../../../ImageWithBackground/ImageWithBackground';
import './СollectionCard.css';
import { AnimatePresence, motion } from 'framer-motion';
import MiniPreloader from '../../../MiniPreloader/MiniPreloader';
import mainAppApi from '../../../../assets/api/MainAppApi';
import moment from 'moment';
import Graph from '../Graph/Graph';
import { Link } from 'react-router-dom';

function СollectionCard({ item }) {
    const [data, setData] = useState(null)
    const [isChartOpen, setChartOpen] = useState(false)
    const [preloaders, setPreloaders] = useState({
        getChart: true,
    })

    function handleLoadChart() {
        if (isChartOpen) {
            setChartOpen(false)
            return
        } else {
            setPreloaders(prevValue => ({
                ...prevValue,
                getChart: true,
            }))
            setChartOpen(true)
            const start = moment().subtract(30, 'days').startOf('day').format('YYYY-MM-DDT00:00:00');
            const end = moment().startOf('day').format('YYYY-MM-DDT00:00:00');
            mainAppApi.getCollectionItemStats({
                _id: item._id,
                start,
                end,
            })
                .then((res) => {
                    setData({
                        ...res,
                        // nonZeroData: res.data.map((item) => {
                        //     return {
                        //         ...item,
                        //         value: Math.floor(Math.random() * 10001),
                        //     }
                        // }) FOR TESTS
                        nonZeroData: res.data.filter(item => item.value !== 0)
                    })
                    console.log(res)
                })
                .catch((err) => {
                    console.log(err)
                })
                .finally(() => {
                    setPreloaders(prevValue => ({
                        ...prevValue,
                        getChart: false,
                    }))
                })
        }
    }
    return (
        <div className='сollection-card'>
            <div className='сollection-card__main'>
                < ImageWithBackground
                    className={`сollection-card__image`}
                    src={item.image ? item.image.urls.orig : IMG_PLACEHOLDER_PRODUCT}
                    image_format={'10x16'}
                    key={`${item.image ? item.image.urls.orig : IMG_PLACEHOLDER_PRODUCT}${item._id}`}
                    metadata={item.image ? item.image.metadata : null}
                />
                <div className='сollection-card__info'>
                    <h3 className={`сollection-card__info-title ${!parseTitleForParts(item.name).subtitle ? 'сollection-card__info-title_major' : ''}`}>{parseTitleForParts(item.name).title}</h3>
                    {parseTitleForParts(item.name).subtitle ? <p className="сollection-card__info-subtitle">{parseTitleForParts(item.name).subtitle}</p> : null}
                    <p className="сollection-card__info-article">{item.reference ? item.reference : ''}</p>
                    <div className='сollection-card__info-separator-line' />
                    <div className='сollection-card__info-price-arrow'>
                        <h3 className='сollection-card__info-price'>{item.price ? parsePrice(item.price, 'USD') : parsePrice(item.purchase_price, 'USD')}</h3>
                        <button className={`сollection-card__info-arrow ${isChartOpen ? 'сollection-card__info-arrow_open' : ''}`} type='button' onClick={handleLoadChart}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.41431 9.53151C6.67307 9.20806 7.14504 9.15562 7.46849 9.41438L12 13.0396L16.5314 9.41438C16.8549 9.15562 17.3269 9.20806 17.5856 9.53151C17.8444 9.85495 17.7919 10.3269 17.4685 10.5857L12.4685 14.5857C12.1946 14.8048 11.8054 14.8048 11.5314 14.5857L6.53145 10.5857C6.208 10.3269 6.15556 9.85495 6.41431 9.53151Z" fill="#1A2530" />
                            </svg>

                        </button>
                    </div>

                </div>
            </div>
            <Link to={`${PROFILE_COLLECTION_EDIT_LINK}/${item._id}`} className='сollection-card__edit'>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.8331 4.34423C19.1937 4.6472 19.5947 5.05862 19.972 5.47843L20.339 5.89779C20.7066 6.32717 20.7068 6.97811 20.3121 7.44789L10.157 19.5341C9.85858 19.8891 9.46707 20.1404 9.03424 20.254L8.8464 20.2938C8.12444 20.4136 7.15564 20.5584 6.32354 20.6307C5.90557 20.667 5.54215 20.683 5.26943 20.6723C5.18739 20.6691 5.12056 20.6623 5.06769 20.6559C5.05235 20.6051 5.03536 20.5408 5.01821 20.4613C4.96069 20.1944 4.91309 19.8333 4.87678 19.4151C4.82261 18.791 4.79552 18.084 4.78268 17.461L4.77456 16.8726C4.77006 16.3587 4.95622 15.8565 5.2971 15.4506L15.4434 3.37495C15.8155 2.93215 16.4082 2.80578 16.886 3.03345L16.9804 3.08347C17.549 3.42282 18.1659 3.81863 18.6393 4.18777L18.8331 4.34423Z" stroke="black" stroke-width="1.4" />
                    <path d="M14.0123 5.73438C14.0123 5.73438 15.1834 7.41599 16.2055 8.08892C17.2276 8.76186 18.4999 9.50159 18.4999 9.50159" stroke="black" stroke-width="1.4" stroke-linecap="round" />
                </svg>
            </Link>
            <AnimatePresence mode='sync'>
                {isChartOpen && (
                    <motion.div
                        initial={{ opacity: 0, height: 0, y: -20, marginTop: 0 }}
                        animate={{ opacity: 1, height: 'auto', y: 0, marginTop: 22 }}
                        exit={{ opacity: 0, height: 0, y: -20, marginTop: 0 }}
                        transition={{ duration: 0.3 }}
                        className='сollection-card__chart'
                    >
                        <p className='сollection-card__chart-title'>Historical Price</p>
                        {console.log(data)}
                        {preloaders.getChart ?
                            <div className='сollection-card__chart-preloader'>
                                <MiniPreloader />
                            </div>
                            :
                            data ?
                                data.nonZeroData.length >= 2 ?
                                    <div className='сollection-card__chart-container'>
                                        <Graph
                                            data={data.nonZeroData.map((item) => {
                                                return {
                                                    ...item,
                                                    name: item.utc_datetime,
                                                }
                                            })}
                                        />
                                    </div>
                                    :
                                    <div className='сollection-card__chart-container-empty-data'>
                                        <p className='сollection-card__chart-container-empty-data-text'>Not enough data to generate a chart</p>
                                    </div>
                                :
                                <div className='сollection-card__chart-container-empty-data'>
                                    <p className='сollection-card__chart-container-empty-data-text'>Not enough data to generate a chart</p>
                                </div>
                        }
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
}

export default СollectionCard